













import Vue from "vue";

export default Vue.extend({
  name: "VCAMenu",
  //   props: {
  //     msg: String,
  //   },
});
